import * as t from "react";
import "./utils-BdNIfrGQ.js";
var r = t.createContext(void 0);
function n(o) {
  const e = t.useContext(r);
  return o || e || "ltr";
}
export {
  n as u
};
